import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineWifi, HiOutlineRefresh } from 'react-icons/hi';

function OfflineIndicator() {
  const { t } = useTranslation();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOnlineMessage, setShowOnlineMessage] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOnlineMessage(true);
      // Hide online message after 3 seconds
      setTimeout(() => {
        setShowOnlineMessage(false);
      }, 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOnlineMessage(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleRetry = () => {
    window.location.reload();
  };

  // Show offline banner
  if (!isOnline) {
    return (
      <div className="offline-indicator offline-indicator--offline">
        <div className="offline-indicator__content">
          <HiOutlineWifi size={20} />
          <span>{t('offline.message')}</span>
        </div>
        <button 
          className="offline-indicator__retry"
          onClick={handleRetry}
        >
          <HiOutlineRefresh size={18} />
          {t('offline.retry')}
        </button>
      </div>
    );
  }

  // Show online restored message temporarily
  if (showOnlineMessage) {
    return (
      <div className="offline-indicator offline-indicator--online">
        <div className="offline-indicator__content">
          <div className="offline-indicator__dot" />
          <span>{t('offline.restored')}</span>
        </div>
      </div>
    );
  }

  return null;
}

export default OfflineIndicator;
